import { STUDENT_DETAIL_ROUTES } from "../../modules/constants";
import AcademicRecords from "./components";
import { resetAcademicRecordsModule } from "./module/AcademicRecordsActions";

export default store => ({
  path: STUDENT_DETAIL_ROUTES.EDIT_GRADES,
  component: AcademicRecords,
  onLeave: () => {
    store.dispatch(resetAcademicRecordsModule());
  },
});
